import { render, staticRenderFns } from "./policies.kubewarden.io.policyserver.vue?vue&type=template&id=1e1339ec&scoped=true&"
import script from "./policies.kubewarden.io.policyserver.vue?vue&type=script&lang=js&"
export * from "./policies.kubewarden.io.policyserver.vue?vue&type=script&lang=js&"
import style0 from "./policies.kubewarden.io.policyserver.vue?vue&type=style&index=0&id=1e1339ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1339ec",
  null
  
)

export default component.exports